// export const CLIENT_NAME = 'demo-local-fs'; // SHOWS ONLY LOCALFS
export const CLIENT_NAME = 'app-dcm-cloud'; // SHOWS BOTH CLOUD AND LOCALFS

const CLIENT_TOOLS = {
  'app-dcm-cloud': [
    //ai
    'AIPredict',
    'AISegmentation',
    'AIGallery',
    'Separator',
    //volume
    'Layout',
    'Mpr2D',
    'Main3D',
    'STL3D',
    // 'PanoramicDental',
    'TrackballRotate',
    'Crosshairs',
    'Separator',
    //basic
    'StackScroll',
    'Zoom',
    'WindowLevel',
    // 'FrameView',
    'Pan',
    'Reset',
    'Separator',
    //annotation
    'MeasurementTools',
    // 'SpineLabeling',
    'MoreTools',
    'Separator',
    //video and image
    'Capture',
    'Cine',
    'TagBrowser',
    'ComparisonCase',
    // 'PrintCase',
    'Separator',
    //panels
    'SegmentTab',
    'MeasurementTab',
    'FindingsTab',
  ],
  'demo-local-fs': [
    //ai
    // 'AIPredict',
    // 'AISegmentation',
    // 'AIGallery',
    'Separator',
    //volume
    'Layout',
    'Mpr2D',
    'Main3D',
    'STL3D',
    // 'PanoramicDental',
    'TrackballRotate',
    'Crosshairs',
    'Separator',
    //basic
    'StackScroll',
    'Zoom',
    'WindowLevel',
    // 'FrameView',
    'Pan',
    'Reset',
    'Separator',
    //annotation
    'MeasurementTools',
    'MoreTools',
    'Separator',
    //video and image
    'Capture',
    'Cine',
    'TagBrowser',
    'ComparisonCase',
    // 'PrintCase',
    'Separator',
    //panels
    'SegmentTab',
    'MeasurementTab',
    'FindingsTab',
  ],
  dkm: [
    //ai
    /* 'AIPredict',
        'AISegmentation',
        'AIGallery',
        'Separator', */
    //volume
    'Layout',
    'Mpr2D',
    'Main3D',
    'TrackballRotate',
    'Crosshairs',
    'Separator',
    //basic
    'StackScroll',
    'Zoom',
    'WindowLevel',
    // 'FrameView',
    'Pan',
    'Reset',
    'WindowLevelRegion',
    'Separator',
    //annotation
    'MeasurementTools',
    'Probe',
    'DragProbe',
    // 'MoreTools',
    // 'Separator',
    //video and image
    'Capture',
    // 'Cine',
    // 'TagBrowser',
    // 'ComparisonCase',
    // 'PrintCase',
    // 'Separator',
    // //panels
    // 'SegmentTab',
    // 'MeasurementTab',
    // 'FindingsTab',
  ],
  indus: [
    //ai
    /* 'AIPredict',
        'AISegmentation',
        'AIGallery',
        'Separator', */
    //volume
    'Layout',
    'Mpr2D',
    'Main3D',
    'TrackballRotate',
    'Crosshairs',
    'Separator',
    //basic
    'StackScroll',
    'Zoom',
    'WindowLevel',
    // 'FrameView',
    'Pan',
    'Reset',
    'WindowLevelRegion',
    'Separator',
    //annotation
    'MeasurementTools',
    'MoreTools',
    'Separator',
    //video and image
    'Capture',
    'Cine',
    'TagBrowser',
    'FindingsTab',
    // 'ComparisonCase',
    // 'PrintCase',
    // //panels
  ],
  dev: [
    //ai
    // 'AIPredict',
    // 'AISegmentation',
    // 'AIGallery',
    'Separator',
    //volume
    'Layout',
    'Mpr2D',
    'Main3D',
    // 'STL3D',
    // 'PanoramicDental',
    'TrackballRotate',
    'Crosshairs',
    'Separator',
    //basic
    'StackScroll',
    'Zoom',
    'WindowLevel',
    'FrameView',
    'Pan',
    'Reset',
    'Separator',
    //annotation
    'MeasurementTools',
    'MoreTools',
    'Separator',
    //video and image
    'Capture',
    'Cine',
    'TagBrowser',
    'ComparisonCase',
    // 'PrintCase',
    'Separator',
    //panels
    'SegmentTab',
    'MeasurementTab',
    'FindingsTab',
  ],
  prod: [
    //ai
    // 'AIPredict',
    // 'AISegmentation',
    // 'AIGallery',
    // 'Separator',
    //volume
    'Layout',
    'Mpr2D',
    'Main3D',
    // 'STL3D',
    'TrackballRotate',
    'Crosshairs',
    'Separator',
    //basic
    'StackScroll',
    'Zoom',
    'WindowLevel',
    'FrameView',
    'Pan',
    'Reset',
    'Separator',
    //annotation
    'MeasurementTools',
    'MoreTools',
    'Separator',
    //video and image
    'Capture',
    'Cine',
    'TagBrowser',
    'ComparisonCase',
    // 'PrintCase',
    'Separator',
    //panels
    'SegmentTab',
    'MeasurementTab',
    'FindingsTab',
  ],
  mrc: [
    //ai
    // 'AIPredict',
    // 'AISegmentation',
    // 'AIGallery',
    // 'Separator',
    //volume
    'Layout',
    'Mpr2D',
    'Main3D',
    // 'STL3D',
    // 'TrackballRotate',
    'Crosshairs',
    'Separator',
    //basic
    'StackScroll',
    'Zoom',
    'WindowLevel',
    // 'FrameView',
    'Pan',
    'Reset',
    'Separator',
    //annotation
    'MeasurementTools',
    'MoreTools',
    'Separator',
    //video and image
    'Capture',
    'Cine',
    'TagBrowser',
    'ComparisonCase',
    // 'PrintCase',
    // 'Separator',
    //panels
    // 'SegmentTab',
    // 'MeasurementTab',
    // 'FindingsTab',
  ],
  demo_mrc: [
    //ai
    // 'AIPredict',
    // 'AISegmentation',
    // 'AIGallery',
    // 'Separator',
    //volume
    'Layout',
    'Mpr2D',
    'Main3D',
    // 'STL3D',
    // 'TrackballRotate',
    'Crosshairs',
    'Separator',
    //basic
    'StackScroll',
    'Zoom',
    'WindowLevel',
    // 'FrameView',
    'Pan',
    'Reset',
    'Separator',
    //annotation
    'MeasurementTools',
    'MoreTools',
    'Separator',
    //video and image
    'Capture',
    'Cine',
    'TagBrowser',
    'ComparisonCase',
    // 'PrintCase',
    // 'Separator',
    //panels
    // 'SegmentTab',
    // 'MeasurementTab',
    // 'FindingsTab',
  ],
  nx: [
    //ai
    // 'AIPredict',
    // 'AISegmentation',
    // 'AIGallery',
    // 'Separator',
    //volume
    'Layout',
    'Mpr2D',
    'Main3D',
    'TrackballRotate',
    'Crosshairs',
    'Separator',
    //basic
    'StackScroll',
    'Zoom',
    'WindowLevel',
    'FrameView',
    'Pan',
    'Reset',
    'WindowLevelRegion',
    'Separator',
    //annotation
    'MeasurementTools',
    'MoreTools',
    'Separator',
    //video and image
    'Capture',
    'Cine',
    'TagBrowser',
    // 'ComparisonCase',
    // 'PrintCase',
    'Separator',
    // //panels
    'SegmentTab',
    'MeasurementTab',
    'FindingsTab',
  ],
  medigence: [
    //ai
    // 'AIPredict',
    // 'AISegmentation',
    // 'AIGallery',
    // 'Separator',
    //volume
    'Layout',
    'Mpr2D',
    'Main3D',
    // 'PanoramicDental',
    'TrackballRotate',
    'Crosshairs',
    'Separator',
    //basic
    'StackScroll',
    'Zoom',
    'WindowLevel',
    // 'FrameView',
    'Pan',
    'Reset',
    'Separator',
    //annotation
    'MeasurementTools',
    'MoreTools',
    'Separator',
    //video and image
    'Capture',
    'Cine',
    'TagBrowser',
    'ComparisonCase',
    // 'PrintCase',
    'Separator',
    //panels
    'SegmentTab',
    'MeasurementTab',
    'FindingsTab',
  ],
  zygeno: [
    //ai
    // 'AIPredict',
    // 'AISegmentation',
    // 'AIGallery',
    // 'Separator',
    //volume
    'Layout',
    'Mpr2D',
    'Main3D',
    // 'PanoramicDental',
    'TrackballRotate',
    'Crosshairs',
    'Separator',
    //basic
    'StackScroll',
    'Zoom',
    'WindowLevel',
    'FrameView',
    'Pan',
    'Reset',
    'Separator',
    //annotation
    'MeasurementTools',
    'MoreTools',
    'Separator',
    //video and image
    'Capture',
    'Cine',
    // 'TagBrowser',
    // 'ComparisonCase',
    // 'PrintCase',
    // 'Separator',
    //panels
    // 'SegmentTab',
    // 'MeasurementTab',
    // 'FindingsTab',
  ],
};

const CLIENT_CONFIGS = {
  dev: {
    KeyImagesXRAD: 'https://dev.xrad.cloud',
    MetaPythonXRAD: 'https://dev.xrad.cloud',
    StudyListXRAD: 'https://dev.xrad.cloud',
    TokenXRAD: 'https://app.dcmcloud.com',
    BucketXRAD: `https://dev.xrad.cloud/app`,
    STLAPI: 'https://dev.xrad.cloud',
  },
  prod: {
    KeyImagesXRAD: 'https://prod-api.xrad.cloud',
    MetaPythonXRAD: 'https://prod-api.xrad.cloud',
    StudyListXRAD: 'https://prod-api.xrad.cloud',
    TokenXRAD: 'https://app.dcmcloud.com',
    BucketXRAD: `https://prod-api.xrad.cloud/app`,
    STLAPI: 'https://prod-api.xrad.cloud',
  },
  mrc: {
    KeyImagesXRAD: 'https://app.dcmcloud.com',
    MetaPythonXRAD: 'https://mrcradiology.com/localFS',
    StudyListXRAD: 'https://app.dcmcloud.com',
    TokenXRAD: 'https://mrcradiology.com/uploadapi/user',
    BucketXRAD: `https://app.dcmcloud.com`,
    STLAPI: 'https://app.dcmcloud.com',
  },
  demo_mrc: {
    KeyImagesXRAD: 'https://app.dcmcloud.com',
    MetaPythonXRAD: 'https://demo.mrcradiology.com/localFS',
    StudyListXRAD: 'https://app.dcmcloud.com',
    TokenXRAD: 'https://demo.mrcradiology.com/uploadapi/user',
    BucketXRAD: `https://app.dcmcloud.com`,
    STLAPI: 'https://app.dcmcloud.com',
  },
  medigence: {
    KeyImagesXRAD: 'https://app.dcmcloud.com',
    MetaPythonXRAD: 'http://app.dcmcloud.com',
    StudyListXRAD: 'http://app.dcmcloud.com',
    TokenXRAD: 'https://app.dcmcloud.com',
    BucketXRAD: `https://app.dcmcloud.com`,
  },
  dkm: {
    KeyImagesXRAD: 'https://api.niruma.in/keyImages',
    MetaPythonXRAD: 'https://api.niruma.in/localFS',
    StudyListXRAD: 'https://api.niruma.in/studyList',
    TokenXRAD: 'https://api.niruma.in/dcmcCore',
    BucketXRAD: `https://api.niruma.in/xrad`,
    STLAPI: 'https://api.niruma.in',
  },
  nx: {
    KeyImagesXRAD: 'http://dcmc.allpractice.com/keyImages',
    MetaPythonXRAD: 'http://dcmc.allpractice.com/localFS',
    StudyListXRAD: 'http://dcmc.allpractice.com/studyList',
    TokenXRAD: 'http://dcmc.allpractice.com/dcmcCore',
    BucketXRAD: `http://dcmc.allpractice.com/studyList`,
    STLAPI: 'https://dcmc.allpractice.com',
  },
  indus: {
    KeyImagesXRAD: 'https://xrad-rad.tih.org.pk/keyImagesV4',
    MetaPythonXRAD: 'https://xrad-rad.tih.org.pk/localFSV4',
    StudyListXRAD: 'https://xrad-rad.tih.org.pk/api',
    TokenXRAD: 'https://xrad-rad.tih.org.pk/dcmCore',
    BucketXRAD: `https://xrad-rad.tih.org.pk/studyListV4`,
    STLAPI: 'https://xrad-rad.tih.org.pk',
  },
  zygeno: {
    KeyImagesXRAD: 'https://dev.xrad.cloud',
    MetaPythonXRAD: 'https://dev.xrad.cloud',
    StudyListXRAD: 'https://dev.xrad.cloud',
    TokenXRAD: 'https://app.dcmcloud.com',
    BucketXRAD: `https://dev.xrad.cloud/app`,
  },
};

const DEFAULT_CLIENT = 'prod';

const isValidClient = clientName => {
  return clientName && CLIENT_CONFIGS.hasOwnProperty(clientName);
};

const isValidClientTools = clientName => {
  return clientName && CLIENT_TOOLS.hasOwnProperty(clientName);
};

export const getClientName = () => {
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search);
    const clientName = searchParams.get('clientName');
    return isValidClient(clientName) ? clientName : DEFAULT_CLIENT;
  }
  return DEFAULT_CLIENT;
};

const getToolsClientName = () => {
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search);
    const clientName = searchParams.get('clientName');
    return isValidClientTools(clientName) ? clientName : CLIENT_NAME;
  }
  return CLIENT_NAME;
};

const getClientConfig = () => {
  const clientName = getClientName();
  return CLIENT_CONFIGS[clientName];
};

const getClientTools = () => {
  const clientName = getToolsClientName();
  return CLIENT_TOOLS[clientName];
};

// BASE URLS (DEPLOYED)
// Override at build time via REACT_APP_BASE_URL in .env
export const baseURL = process.env.REACT_APP_BASE_URL || 'https://app.dcmcloud.com';
export const API = `${baseURL}`; // File Reader .NET Core, File Loader .NET Core & Node.js
export const CloudAPI = `${baseURL}`; // 8011 Metadata
export const LocalAPI = `${baseURL}`; // 8003 File Reader & File Loader Local
export const LocalMetadataAPI = `${baseURL}`; // 5002 Metadata Local
export const LocalKeyImages = `${baseURL}`; // 8001 Key Images Local
export const KeyImagesAPI = `${baseURL}`; // 8002 Key Images Cloud
export const LocalAPIUpload = `${baseURL}`; // 5016 Metadata Local
export const PanoAPI = `${baseURL}`; // 8001 Pano Dentistry API
export const DentistrySegAPI = `${baseURL}`; // 9007 Dentistry Segmentation API
export const STLAPI = `${baseURL}`;

// BASE URLS (DEVELOPMENT)
// export const baseURL = 'http://192.168.1.6';
// export const API = `https://app.dcmcloud.com`; //File Reader .NET Core, File Loader .NET Core & Node.js
// export const CloudAPI = `https://app.dcmcloud.com`; //8011 //Metadata
// export const LocalAPI = `${baseURL}:5003`; //5003 //File Reader & File Loader Local
// export const LocalMetadataAPI = `${baseURL}:5002`; //5002 //9044 //Metadata Local
// export const LocalAPIUpload = `${baseURL}:5016`; //5016 //Metadata Local
// export const LocalKeyImages = `https://app.dcmcloud.com`; //8001 //Key Images Local
// export const KeyImagesAPI = `https://app.dcmcloud.com`; //8015 //Key Images Cloud
// export const PanoAPI = `https://app.dcmcloud.com`; //8003 //Pano Dentistry API
// export const STLAPI = `http://192.168.100.112:7015`; //8003 //Pano Dentistry API
// export const DentistrySegAPI = `${baseURL}:9007`;

//API KEYS — loaded from environment variables (.env file, gitignored)
// Set REACT_APP_XRAD_API_KEY / REACT_APP_NET_ENCRYPT_KEY / REACT_APP_ENCRYPT_KEY in your .env
export const XRADAPIKEY = process.env.REACT_APP_XRAD_API_KEY || '';
export const netEncryptKey = process.env.REACT_APP_NET_ENCRYPT_KEY || '';
export const encryptKey = process.env.REACT_APP_ENCRYPT_KEY || '';

// XRAD ROUTES
export const TokenVerifyAPI = getClientConfig().TokenXRAD;
export const LocalKeyImagesXRAD = getClientConfig().KeyImagesXRAD;
export const LocalAPIXRAD = getClientConfig().MetaPythonXRAD;
export const BucketXRAD = getClientConfig().BucketXRAD;
export const LocalStudylistXRAD = getClientConfig().StudyListXRAD;
export const STLAPIXRAD = getClientConfig().STLAPI;

//CLIENT TOOLS

export const clientToolNames = getClientTools();
